module.exports = __webpack_public_path__ + "static/media/hero_mobile.557ca0bf.webp";